import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MenuItem, ButtonToolbar, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import i18n from '../i18next/i18next';
import Config from '../../Config';

import '../../assets/css/header.css';

class Header extends Component {
  gotoProfile = event => {
    event.preventDefault();
    this.props.history.push('/profile');
  };

  doLogout = event => {
    event.preventDefault();
    const { setUserInfo } = this.props;
    axios
      .get(Config.baseUrl + 'oauth/revoke', {
        params: {
          client_id: Config.clientId,
          access_token: Config.curUser.access_token,
          revoke_type: 'token'
        }
      })
      .then(response => {
        localStorage.removeItem('dlinkuser');
        setUserInfo('', '');
        this.props.history.push('/');
      })
      .catch(error => {
        localStorage.removeItem('dlinkuser');
        setUserInfo('', '');
        this.props.history.push('/');
      });
  };

  renderUserSection = () => {
    const { language, name, email, location } = this.props;

    if (location.pathname !== '/profile') {
      return null;
    }

    return (
      <div className="user-wrap col-md-6 col-sm-6 col-xs-6 text-right">
        <div className="user">
          <div className="d-md">
            <i className="fa fa-user-circle-o" aria-hidden="true" />
            <Link to="/profile" className="username">
              {name}
            </Link>
            <a href="/" onClick={this.doLogout}>
              <span className="left-space" />
              {i18n.t('signout', { lng: language })}
            </a>
          </div>
          <div className="d-sm select custom">
            <ButtonToolbar className={`user-dropdown-bar`}>
              <Dropdown id="user-dropdown">
                <Dropdown.Toggle
                  bsStyle="primary"
                  className={`btn btn-outline-secondary btn-xs delete btn btn-default language`}
                  noCaret
                >
                  <i className="fa fa-user-circle-o" aria-hidden="true" />
                  {name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem onClick={this.gotoProfile}>{email}</MenuItem>
                  <MenuItem className="signout" onClick={this.doLogout}>
                    {i18n.t('signout', { lng: language })}
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </ButtonToolbar>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const user = JSON.parse(localStorage.getItem('dlinkuser'));
    const isLogin = user && user.access_token ? true : false;
    const linkTo = isLogin ? '/profile' : '/';

    return (
      <div className="header">
        <div className="header_area">
          <div className="logo_in_header">
            <Link to={linkTo}>
              <img
                data-ta-type="ignore"
                src={require('../../assets/images/d-link_logo.svg')}
                alt={i18n.t('dLink')}
                title={i18n.t('dLink')}
              />
            </Link>
          </div>
          {this.renderUserSection()}
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js